import { render, staticRenderFns } from "./m-orm-tax-rates-form-dialog.vue?vue&type=template&id=5f07cea0&scoped=true&lang=pug&"
import script from "./m-orm-tax-rates-form-dialog.vue?vue&type=script&lang=js&"
export * from "./m-orm-tax-rates-form-dialog.vue?vue&type=script&lang=js&"
import style0 from "./m-orm-tax-rates-form-dialog.vue?vue&type=style&index=0&id=5f07cea0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f07cea0",
  null
  
)

export default component.exports